export default (value: string | undefined) => value || null;
